"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
* Enum class Relationship.
* @enum {}
* @readonly
*/
var Relationship = /*#__PURE__*/function () {
  function Relationship() {
    _classCallCheck(this, Relationship);

    _defineProperty(this, "GRANDPARENT", "GRANDPARENT");

    _defineProperty(this, "PARENT", "PARENT");

    _defineProperty(this, "SPOUSE", "SPOUSE");

    _defineProperty(this, "SIGNIFICANT OTHER", "SIGNIFICANT OTHER");

    _defineProperty(this, "SIBLING", "SIBLING");

    _defineProperty(this, "CHILD", "CHILD");

    _defineProperty(this, "AUNT/UNCLE", "AUNT/UNCLE");

    _defineProperty(this, "NIECE/NEPHEW", "NIECE/NEPHEW");

    _defineProperty(this, "COUSIN", "COUSIN");

    _defineProperty(this, "GRANDCHILD", "GRANDCHILD");

    _defineProperty(this, "IN-LAW", "IN-LAW");

    _defineProperty(this, "OTHER", "OTHER");
  }

  _createClass(Relationship, null, [{
    key: "constructFromObject",

    /**
    * Returns a <code>Relationship</code> enum value from a Javascript object name.
    * @param {Object} data The plain JavaScript object containing the name of the enum value.
    * @return {module:model/Relationship} The enum <code>Relationship</code> value.
    */
    value: function constructFromObject(object) {
      return object;
    }
  }]);

  return Relationship;
}();

exports.default = Relationship;